/*
 * Layout for the account admin section
 */

define(["marionette", "slideout", "./template/accountAdminTemplate.html"], function (
  Marionette,
  Slideout,
  AccountAdminTemplate,
) {
  var AccountAdminView = {
    accountAdminLayout: Marionette.Layout.extend({
      template: AccountAdminTemplate,
      regions: {
        userMenu: "#user-menu",
        sideMenu: "#sideMenu",
        accountAdmin: "#accountAdmin",
      },
      triggers: {
        "click .toggle-button": "toggle:slideout",
      },
      onRender: function () {
        var panel = this.$el.find("#account-admin-main")[0];
        var menu = this.$el.find("#navbar-admin")[0];
        this.slideout = new Slideout({
          panel: panel,
          menu: menu,
          padding: 256,
          tolerance: 70,
        });
      },
      onBeforeClose: function () {
        this.slideout.close();
      },
      hideSlideout: function () {
        this.slideout.close();
      },
      showSlideout: function () {
        this.slideout.open();
      },
    }),
  };

  return AccountAdminView;
});
